import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const WINCardDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const {
    CPTCodeDesc,
    AuthorizationNumber,
    RequestedFromToDate,
    RequestedFromDate,
    ApprovedAmount,
    WINCardURL,
    cardType,
  } = location.state || {};

  const [iframeLoading, setIframeLoading] = useState(true);

  // Extract redeem code from WINCardURL
  const getRedeemCode = () => {
    try {
      const url = new URL(WINCardURL);
      const externalRequestorId = url.searchParams.get("external_requestor_id");
      return externalRequestorId ? externalRequestorId.substring(0, 8) : "";
    } catch (e) {
      return "";
    }
  };

  if (!WINCardURL) {
    return (
      <div>
        <button onClick={() => navigate(-1)} className="win-back-btn">
          <span>
            <i className="bi bi-chevron-left"></i> {t('back')}
          </span>
        </button>
        <p className="d-flex justify-content-center mt-5">{t('nocarddetails')}</p>
      </div>
    );
  }

  return (
    <>
      <div className="col-md-12 col-lg-12 mt-md-4 mt-sm-0 inner-page-heading-wrapper">
        <button className="win-back-btn" onClick={() => navigate(-1)}>
          <span>
            <i className="bi bi-chevron-left"></i> {t('back')}
          </span>
        </button>
        <h2 className="page-heading">{t('wincarddetails')}</h2>
      </div>

      <div className="card-details-container">
        <div className="card-info">
          {cardType === 'wincentive' ? (
            <>
              <p><strong>Redeem Code:</strong> {getRedeemCode()}</p>
              <p><strong>Redeem Date:</strong> {RequestedFromDate || ''}</p>
              <p><strong>Redeem Amount:</strong> {ApprovedAmount || ''}</p>
            </>
          ) : (
            <>
              <p><strong>{t('cptdesc')}</strong> {CPTCodeDesc || ''}</p>
              <p><strong>{t('authrizationnumber')}</strong> {AuthorizationNumber || ''}</p>
              <p><strong>{t('requestfromtodate')}</strong> {RequestedFromToDate || ''}</p>
            </>
          )}
          {/* <p>
            <strong>Card Type: </strong>
            {cardType === 'benefit'
              ? 'Benefit Card'
              : cardType === 'wincentive'
              ? 'Wincentive Card'
              : 'Unknown'}
          </p> */}
        </div>

        <div className="iframe-container" style={{ marginTop: "20px" }}>
          {iframeLoading && (
            <div style={{ textAlign: "center", marginBottom: "10px" }}>
              <span>{t('loading') || 'Loading card...'}</span>
            </div>
          )}
          <iframe
            src={WINCardURL}
            title="WIN Card"
            width="100%"
            height="500px"
            style={{ border: "1px solid #ccc" }}
            onLoad={() => setIframeLoading(false)}
          />
        </div>
      </div>
    </>
  );
};

export default WINCardDetails;
